module.exports = __webpack_public_path__ + "static/media/slide1.ff38d1b2.jpg";